import axios from 'axios';
import { getAccessToken } from '@oliasoft/pkce';
import ClientConfig from '~client/config';
import resolveErrors from './errorResolver';
import { loadLocalStoreData } from '../services/local-storage.service';

const baseURL = '/adm/api';

const httpClient = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Language': loadLocalStoreData('locales',  'en'),
  }
});

const requestHandler = axiosConfig  => {
  let token = null;
  if (!ClientConfig.config.pkce.provider) {
    token = 'NO_PKCE_ACCESS_TOKEN_YET';
  } else {
    const accessToken = getAccessToken(
      ClientConfig.config.pkce.provider,
      ClientConfig.config.clientId,
      ClientConfig.config.idpServerUrl,
    );
    token = accessToken;
  }

  if (token) {
    axiosConfig.headers.Authorization = `Bearer ${token}`;
  }
  return axiosConfig;
};

const successHandler = response => response;

const errorHandler = error => {
  const { status, data } = error.response;
  resolveErrors(status, data);
  return Promise.reject(error);
};

httpClient.interceptors.request.use(requestHandler);

httpClient.interceptors.response.use(successHandler, errorHandler);

export default httpClient;
